module.exports = __webpack_public_path__ + "static/media/onboarding-rewards-min.57245588.jpg";